import React, { useState, useEffect } from 'react';
import DynamicForm from "../../../../../customformComponent/customForm/DynamicForm";
import backicon from './../../../../../../Assets/icons/backIcon.svg';
import './index.scss';
import { useLocation, useNavigate } from 'react-router-dom';
import axiosInstance from '../../../../../services/api/API';
import Loader from '../../../../../customComponents/CustomLoader';
import Swal from 'sweetalert2';

const AddNewDealerBranch = () => {
  const [formData, setFormData] = useState({});
  const [validationErrors, setValidationErrors] = useState({});
  const [dealerOptions, setDealerOptions] = useState([]);
  const [ userTypedd, setUserTypedd ] = useState([])
  const userType = localStorage.getItem("UserType")
  const businessPartnerId = localStorage.getItem("business_partner_id")
  const dealerId = localStorage.getItem("dealerId")
  const dealerType = localStorage.getItem("UserType")
  const location = useLocation();
  const { data } = location.state || {};
  const [loading, setLoading] = useState(false);

useEffect(() => {
  userTypedropdown()
},[])

const userTypedropdown = async () => {
  try{
    const response = await axiosInstance.get("/bp-onboard/bplist",{
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
    })

    const data = response.data.data.data
    const userTypeOptions = data.map(user => ({
      value: user.onboard_id,
      label:user.bp_name,
    }))
    setUserTypedd(userTypeOptions)
  }catch(error) {
    console.log(error)
  }
}
  const navigate = useNavigate();

  useEffect(() => {
    if(formData?.business_partner_id || userType != "superadmin" )
    fetchDealerOptions();
  }, [formData?.business_partner_id]);


  const authToken = localStorage.getItem("authToken");

 

  const fetchDealerOptions = async () => {
    try {
      const response = await axiosInstance.post('/dealer/list',
      { 
        orderBy:"dealer_id desc",
         business_partner_id:userType==="superadmin"?formData?.business_partner_id :businessPartnerId},{
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        }
      });

      const options = response.data.data.data.map(dealer => ({
        label: dealer.dealer_name,
        value: dealer.dealer_id
      }));
      setDealerOptions(options);
    } catch (error) {
      console.error('Error fetching dealer options:', error);
    }
  };



  const DealerBranchInputs = [
    ...(userType === "superadmin"
      ? [
          {
            name: "business_partner_id",
            label: "Business Partner",
            type: "dropdown",
            required: true,
            options: userTypedd,
            gridClass: "col-lg-4",
            
          },
        ]
      : []),

      ...(dealerType !== "dealeruser"
        ? [
          {
            name: "dealer_id",
            label: "Dealer Name",
            type: "dropdown",
            required: true,
            options: dealerOptions,
            gridClass: "col-lg-4",
            
          }
        ]
        : []
      ),
    {
      name: "branch_name",
      label: "Dealer Branch Name",
      placeholder:"Enter Dealer Branch Name",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: { required: true,
        pattern: /^[A-Za-z\s]*$/,
              message: "Only alphabets and digits are allowed",
              maxLength:20
             },
    },
    {
      name: "branch_desc",
      label: "Dealer Branch Desc",
      placeholder:"Enter Dealer Branch Description",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: { required: true },
    },
    {
      name: "contact_no",
      label: "Contact No",
      placeholder:"Enter Contact Number",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: { 
        required: true, pattern: /^[6-9]/ ,
        minLength:10,
        maxLength:10,
        message1: "Contact no should start with 6, 7, 8, 9",
        message: "Please enter a valid 10-digit",
      }
    },
    {
      name: "pincode",
      label: "Pin Code",
      placeholder:"Enter Pin Code",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: { required: true, maxLength:6 },
     
    },
    {
      name: "country",
      label: "Country",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: { required: true },
      disabled:"true"
    },
    {
      name: "state",
      label: "State",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: { required: true },
       disabled:"true"
    },
    {
      name: "city",
      label: "City",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: { required: true },
       disabled:"true"
    },
    {
      name: "branch_address",
      label: "Branch Address",
      placeholder:"Enter Branch Address",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: { required: true },
    },
    {
      name: "email_id",
      label: "Email Address",
      placeholder:"Enter Email Address",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: { required: true, pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/ , message: "Please enter a valid Email Address"},

    },
    {
      name: "tin",
      label: "TIN NO",
      type: "text",
      placeholder:"Enter Tin",
      // required: true,
      gridClass: "col-lg-4",
      // validation: { required: true },
    },
       {
    name: "pan",
    label: "PAN No.",
    type: "text",
    placeholder: "Enter PAN No.",
    validation: { 
      // required: true, 
      pattern: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, 
      message: "Please enter a valid 10-character PAN number",
      maxLength:10
    },
    // required: true,
    gridClass: "col-lg-4",
  },
  {
    name: "gst",
    label: "GST No.",
    type: "text",
    placeholder: "Enter GST No.",
    validation: { 
      // required: true, 
      pattern: /^\d{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[A-Z0-9]{1}Z[A-Z0-9]{1}$/, 
      message: "Please enter a valid 15-character GST number",
      maxLength:15
    },
    // required: true,
    gridClass: "col-lg-4",
  },
    {
      name: "status",
      label: "Status",
      type: "dropdown",
      required: true,
      options: [
        { id: 1, label: "Active", value: 1 },
        { id: 0, label: "Inactive", value: 2 },
      ],
      gridClass: "col-lg-4",
      validation: { required: true },
    },
  ];


  const handleFormSubmit = async (formData) => {
    const errors = {};
    let isValid = true;
  
    DealerBranchInputs.forEach((field) => {
      if (field.validation && field.validation.required) {
        if (!formData[field.name]) {
          errors[field.name] = "This field is required";
          isValid = false;
        } else if (field.required && field.validation && field.validation.pattern && !field.validation.pattern.test(formData[field.name])) {
          errors[field.name] = field.validation.message;
          isValid = false;
        }
      }
    });
  
    if (!isValid) {
      setValidationErrors(errors);
      return;
    }
  
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to add this Dealer Branch?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          setLoading(true);
  
          const payload = {
            contact_no: formData.contact_no,
            showroom_name: formData.branch_name,
            showroom_desc: formData.branch_desc,
            showroom_address: formData.branch_address,
            emailid: formData.email_id,
            showroom_pincode: formData.pincode,
            country_id: formData.country_id,
            state_id: formData.state_id,
            city_id: formData.city_id,
            tin: formData.tin,
            pan: formData.pan,
            gst: formData.gst,
            status: formData.status,
          };
  
          if (userType !== "dealeruser") {
            payload.dealer_id = formData?.dealer_id;
          } else {
            payload.dealer_id = dealerId;
          }
  
          if (userType === "superadmin") {
            payload.business_partner_id = formData.business_partner_id;
          } else {
            payload.business_partner_id = businessPartnerId;
          }
  
          const response = await axiosInstance.post('/showroom/create', payload, {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${authToken}`,
            },
          });
  
          console.log("Dealer Branch added successfully:", response.data);
  
          if (response.status === 200) {
            Swal.fire({
              title: "Success",
              text: "Dealer Branch added successfully!",
              icon: "success",
              confirmButtonText: "OK",
            }).then(() => {
              navigate('/admin/manage-dealer/dealer-branch');
            });
          }
  
        } catch (error) {
          const errorMessage = error.response?.data?.message || "An error occurred while processing your request.";
          
          Swal.fire({
            title: "Error",
            text: errorMessage,
            icon: "error",
            confirmButtonText: "OK",
          });
  
          console.error('Error adding dealer branch:', error);
        } finally {
          setLoading(false);
        }
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        // Handle cancel action
        Swal.fire({
          title: "Cancelled",
          text: "Your changes were not saved.",
          icon: "info",
          confirmButtonText: "OK",
        });
        setLoading(false); // Reset loading when action is canceled
      } else {
        setLoading(false); // Ensure loader is reset in any other case
      }
    });
  };
  


  return (
    <>
     {loading ? (
          <Loader />
        ) : (
          <>
      <div className="backbutton mt-2 mb-2" onClick={() => navigate(-1)}>
        <img src={backicon} alt="back" />
        <span className="backbtntitle">Add New Dealer Branch</span>
      </div>
      <div className="form-container">
        <span className="cust-det-title mt-2 mb-2">
          Please Enter Dealer Branch Details
        </span>
        <DynamicForm
          formConfig={DealerBranchInputs}
          formData={formData}
          setFormData={setFormData}
          onSubmit={handleFormSubmit}
          validationErrors={validationErrors}
          setValidationErrors={setValidationErrors}
        />
      </div>
      <div className="btncontainer mt-3">
        <button
          onClick={() => {
            handleFormSubmit(formData);
          }}
          className="submit-btn"
        >
          Submit
        </button>
      </div></>
        )}
    </>
  );
};

export default AddNewDealerBranch;
